const { setCookie } = require('../cookies')
const { size } = require('../size')
const { isDirectTraffic } = require('./is-direct-traffic')

// ? ******************************************************************************************
// ? ******************************************************************************************

function setOrgReferer () {
  if (typeof document === 'undefined') return

  const referer = document?.referrer

  if (!size(referer)) return
  if (isDirectTraffic(referer)) return

  setCookie('OrgReferer', referer, 30)

  return referer
}

module.exports = { setOrgReferer }
